import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import createSagaMiddleware from 'redux-saga';

import apiMiddleware from './api/middleware';
import externalApiMiddleware from './externalApi/middleware';
import { projectMiddleware } from './features/project';
import rootReducers from './reducers';
import rootSaga from './sagas';
import { defaultConnection } from './sockets/sockets';

const { preloadedState } = window as Window;

const sagaMiddleware = createSagaMiddleware({
    context: {
        socketConnection: defaultConnection,
    },
});

const middlewares = [sagaMiddleware, ...apiMiddleware, ...externalApiMiddleware, projectMiddleware];

/*
 * Exclude logger from production and test environments. For some reason if the redux-logger is imported with js module
 * syntax it adds logs when running tests and it happens regardless of whether it is or is not enabled. This is a
 * workaround to keep it silent in testing environment.
 * */
if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && process.env.REDUX_LOGGER === 'true') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
    const logger = require('redux-logger').default;

    middlewares.push(logger);
}

export const middleware = getDefaultMiddleware({
    /*
     * Reason we turned off immutability check in development environment is because custom `contains` in array prototype at
     * line services/app/legacy-public-src/js/func.js:112 (`Array.prototype.contains = function (obj) {`). We need to get rid of it
     * first and replace it with native `.includes()` call there and in other places that might rely on it.
     * Since it is set false by default in the production then lets explicitly set to "false".
     * */
    immutableCheck: false,
    /*
     * Jest is set up to fail whenever there is a warning. Since this warning could happen randomly during test runs
     * it is disabled while testing.
     * */
    serializableCheck: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',
}).concat(middlewares);

const store = configureStore({
    reducer: rootReducers,
    preloadedState,
    middleware,
});

setupListeners(store.dispatch);

sagaMiddleware.run(rootSaga);

export default store;
